import Empresa from "@/features/contabil/common/Empresa";
import EmpresaMapper from "@/features/contabil/common/EmpresaMapperAdapter";
import { IEmpresaResponse } from "../requests/types";

export interface ITiposDiagnostico {
  companyInfo: string | null;
  corporateBoard: string | null;
  cadin: string | null;
  situacaoFiscal: string | null;
  obrigacoes: string | null;
  balanco: string | null;
  faturamento: string | null;
  fontesPagadoras: string | null;
  tributosSobreFaturamento: string | null;
  warnings: string | null;
}

type EmpresaDiagnosticoResponse = IEmpresaResponse & ITiposDiagnostico;

export interface IDiagnosticoResponse extends ITiposDiagnostico {
  empresas: EmpresaDiagnosticoResponse[];
}

export default class Diagnostico {
  constructor(readonly response: IDiagnosticoResponse | undefined) {}

  setDiagnostico(empresas: Empresa[]): Empresa[] {
    return empresas.map((empresa) => {
      const empresaEncontrada = this.response?.empresas.find(
        (empresaResponse) => empresaResponse.id === empresa.getProps().id
      );

      if (!empresaEncontrada) return empresa;

      return EmpresaMapper.toEntity(empresa as IEmpresaResponse, {
        ...empresaEncontrada,
        balanco: empresaEncontrada.balanco,
        cadin: empresaEncontrada.cadin,
        companyInfo: empresaEncontrada.companyInfo,
        corporateBoard: empresaEncontrada.corporateBoard,
        faturamento: empresaEncontrada.faturamento,
        fontesPagadoras: empresaEncontrada.fontesPagadoras,
        obrigacoes: empresaEncontrada.obrigacoes,
        situacaoFiscal: empresaEncontrada.situacaoFiscal,
        tributosSobreFaturamento: empresaEncontrada.tributosSobreFaturamento,
        warnings: empresaEncontrada.warnings
      });
    });
  }
}
